// Invite page
// - Reads :token from URL
// - Renders <h1> error if token is missing
// - Passes token to InviteCard

import { useParams } from 'react-router-dom';
import InviteCard from '../components/InviteCard';
import Layout from '../components/Layout';

export default function PageInvite() {
  const { token } = useParams();

  if (!token) {
    return (
      <Layout screenSized className='page-invite'>
        <h1>Error: invalid invite link</h1>
      </Layout>
    );
  }

  return (
    <Layout screenSized className='page-invite'>
      <InviteCard token={token} />
    </Layout>
  );
}
